import React ,{useState,useEffect} from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form
} from "react-bootstrap";

import "../assets/styling/Styles.css";
import api from '../api/api';
import LoadingSpinner from "../components/common/LoadingSpinner";
import { useTranslation } from "react-i18next";
import TempChart from "../components/blog/TempChart";
import PressionChart from "../components/blog/PressionChart";
import HumidityChart from "../components/blog/HumidityChart";
import SubSoilHumidityChart from "../components/blog/SubSoilHumidityChart";
import { useNavigate, useParams } from "react-router-dom";
import "./Graph.css";
import { getSensorDepths } from "../utils/sensorDepths";


const Graph = () => {
  const [selectedChart, setSelectedChart] = useState("");


  const handleSelectChart = (chartName) => {
    setSelectedChart(chartName);
  };

  
  const handleClearSelection = () => {
    setSelectedChart("");
  };
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { uid } = useParams();

      const [name,setName] = useState('')
      const [sensors,setSensors ] = useState([])
      const [dataSensor,setDataSensors] = useState([])
      const [value ,setValue ] = useState("")
      const [isLoading,setIsLoading]= useState(true)
      const sensorDepths = getSensorDepths(
        sensors.find((sensor) => sensor.code === value)
      )
 
  const storedFieldUid = localStorage.getItem('Field');
  const Uid = uid || (storedFieldUid && storedFieldUid !== "0" ? storedFieldUid : null);

  useEffect(() => {
    if (!Uid) {
      setIsLoading(false);
      return;
    }

    localStorage.setItem("Field", Uid);
    getSensorsCodes();
    getSelectedField();
  }, [Uid]);

  useEffect(() => {
    if (!value) {
      setDataSensors([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    getHistorySensor();
  }, [value]);
  
  const getSelectedField = async () => {
    try {
      const response = await api.get("/field/fields");
      const farms = response.data?.farms || [];
      const field = farms
        .flatMap((farm) => farm.fields || [])
        .find((item) => String(item.uid) === String(Uid));
      setName(field?.name || "");
    } catch (error) {
      console.error("Unable to load field name:", error);
      setName("");
    }
  };


const getHistorySensor = async () => {
  
  let dateEnd = new Date();
  let dateStart = new Date(dateEnd); 
  
  dateStart.setDate(dateEnd.getDate() - 7);
    await  api.get(`/sensor/sensor-history/${value}/${dateStart}/${dateEnd}?pageNum=${1}&limit=21`)
      .then(response=>{
          const historyResult = Array.isArray(response.data?.history)
            ? response.data.history
            : [];
          setDataSensors(historyResult)
        

      })
      .catch(err=>{
          console.error(err)
          setDataSensors([])
      }).finally(() => setIsLoading(false))

  
 }
  const getSensorsCodes = async () => {
   await api.get(`/field/${Uid}/sensors`)
    .then(response => {
      const fieldSensors = Array.isArray(response.data?.sensors)
        ? response.data.sensors
        : [];
      const storedCode = localStorage.getItem("code");
      const selectedCode = fieldSensors.some((sensor) => sensor.code === storedCode)
        ? storedCode
        : fieldSensors[0]?.code || "";

      setSensors(fieldSensors)
      setValue(selectedCode)
      if (selectedCode) localStorage.setItem("code", selectedCode)
      if (!selectedCode) {
        setDataSensors([])
        setIsLoading(false)
      }
    })
    .catch(err=>{
      console.error(err)
      setSensors([])
      setValue("")
      setDataSensors([])
      setIsLoading(false)
    })
    
  }


 
    return (
      <Container fluid className="graph-page px-3 px-md-4 py-3 py-md-4">
        <header className="graph-page-hero">
          <div>
            <span className="graph-page-eyebrow">SMARTFARM · {t("sensors")}</span>
            <h1>{name || t("sensors")}</h1>
            <p>{t("graph_detailed_subtitle", { defaultValue: "Detailed graphs" })}</p>
          </div>
          <Button
            variant="outline-secondary"
            className="graph-back-button"
            onClick={() => navigate(Uid ? `/Fields/${Uid}` : "/overview")}
          >
            <i className="fas fa-arrow-left" aria-hidden="true" />
            <span>{t("field")}</span>
          </Button>
        </header>
        {
          isLoading
          ?
          <LoadingSpinner />
          :
          sensors.length === 0 ? (
          <section className="graph-empty-state">
            <span><i className="fas fa-chart-line" aria-hidden="true" /></span>
            <h2>{t("graph_no_sensor_title", { defaultValue: "Aucun capteur à analyser" })}</h2>
            <p>{t("graph_no_sensor_help", { defaultValue: "Ce terrain ne possède pas encore de capteur avec des données disponibles." })}</p>
            <Button onClick={() => navigate(`/Fields/${Uid}`)} className="graph-empty-back">
              <i className="fas fa-arrow-left" aria-hidden="true" />
              {t("field")}
            </Button>
          </section>
          ) : (
          <>
        <Row className="graph-filter-row d-flex justify-content-center py-4">
          <Col lg="4" md="6" sm="6" >
          <Form.Select className="graph-sensor-select" value={value || ""} onChange={e => setValue(e.target.value)}>
            <option value="">{t('select_sensor')}</option>
            {
              sensors.map(sensor =>{
                return <option key={sensor.code} value={sensor.code}>{sensor.code}</option>
              })
            }
          </Form.Select>
          </Col>
        </Row>
        {/* First Row of Posts */}
        <Row className="graph-grid gap-4">
        {selectedChart ? ( 
          <Col lg="12" md="12" sm="12" className="mb-4">
            <Row className="d-flex justify-content-center m-2">
                  <Button onClick={handleClearSelection} className="graph-see-all-button" variant="outline-info">
                    {t("see_all")}
                  </Button>
                </Row>
            {selectedChart === "TempChart" && (
              <TempChart title={t("Temp.")} data={dataSensor} onSelect={handleSelectChart} />
            )}
            {selectedChart === "PressionChart" && (
              <PressionChart
                title={t("Pression")}
                data={dataSensor}
                onSelect={handleSelectChart}
              />
            )}
            {selectedChart === "HumidityChart" && (
              <HumidityChart
                title={t("Humidity")}
                data={dataSensor}
                onSelect={handleSelectChart}
              />
            )}
            {selectedChart === "SubSoilHumidityChart" && (
              <SubSoilHumidityChart
                title={t("subsoil_humidity", { defaultValue: "Subsoil Humidity" })}
                data={dataSensor}
                sensorDepths={sensorDepths}
                onSelect={handleSelectChart}
              />
            )}
           
          </Col>
        ) : ( // If no chart is selected, show all four charts
          <>
            <Col lg="6" md="12" sm="12" className="mb-4">
              <TempChart title={t("Temp.")} data={dataSensor} onSelect={handleSelectChart} />
            </Col>
            <Col lg="5" md="12" sm="12" className="mb-4">
              <PressionChart
                title={t("Pression")}
                data={dataSensor}
                onSelect={handleSelectChart}
              />
            </Col>
            <Col lg="6" md="12" sm="12" className="mb-4">
              <HumidityChart
                title={t("Humidity")}
                data={dataSensor}
                onSelect={handleSelectChart}
              />
            </Col>
            <Col lg="5" md="12" sm="12" className="mb-4">
              <SubSoilHumidityChart
                title={t("subsoil_humidity", { defaultValue: "Subsoil Humidity" })}
                data={dataSensor}
                sensorDepths={sensorDepths}
                onSelect={handleSelectChart}
              />
            </Col>
          </>
        )}
      </Row>
        </>
          )
        }
      </Container>
    );
  }

export default Graph;
